import { GET_STATUS_REQUEST, GET_STATUS_SUCCESS, GET_STATUS_FAILURE, GetStatusActionTypes, GetStatusState } from './types';
import { defaultState } from 'store/types';

export default function getStatuses(state = defaultState, action: GetStatusActionTypes): GetStatusState {
  switch (action.type) {
    case GET_STATUS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_STATUS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_STATUS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
